import { render, staticRenderFns } from "./ScoreCards_Summit.vue?vue&type=template&id=6dd1d0d6&"
import script from "./ScoreCards_Summit.vue?vue&type=script&lang=js&"
export * from "./ScoreCards_Summit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports